import { FilterButton, Menu } from '@pocketlaw/tetris';
import { MenuSingleSelectItem } from 'shared/domains/common-ui/SearchableMenu';
import { useFilter } from '../useFilter';
/**
 * Component to display a dropdown of filter operators.
 */
export function OperatorSelector(props) {
    const { name, label, operators } = props;
    const filter = useFilter(name);
    const handleSelect = (operator) => {
        operator.onSelect();
    };
    const isActive = (operator) => {
        const idArray = Array.isArray(operator.id) ? operator.id : [operator.id];
        return idArray.includes(filter.operator);
    };
    const selectedOperator = operators.find((operator) => operator.id === filter.operator);
    return (<Menu.Root target={<FilterButton appearance={filter.isTouched ? 'draft' : 'default'}>
          {label && <b>{label}</b>} {selectedOperator === null || selectedOperator === void 0 ? void 0 : selectedOperator.label}
        </FilterButton>}>
      {operators.map((operator) => (<MenuSingleSelectItem key={operator.id.toString()} selected={isActive(operator)} onClick={() => handleSelect(operator)}>
          {operator.menuItem}
        </MenuSingleSelectItem>))}
    </Menu.Root>);
}
